import { useCallback, useState } from 'react';
import { useMutation } from '@apollo/client';
import GravSparaBildMutation from '../Mutations/GravSparaBildMutation.gql';
import { uploadFile } from '../../../../../../Utils/fileUtils';

export const useSparaGravplatsBild = (
  gravId: number,
  activeDatabase: string
) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);
  const [sparaBildMutation] = useMutation(GravSparaBildMutation);

  const sparaBild = useCallback(
    async (file: File): Promise<string | undefined> => {
      setLoading(true);
      setError(null);
      try {
        const blobId = await uploadFile(file, activeDatabase);

        await sparaBildMutation({
          variables: {
            dbname: activeDatabase,
            GravID: gravId,
            BildBlob: blobId,
          },
        });

        return blobId;
      } catch (e) {
        setError(e as Error);
        return undefined;
      } finally {
        setLoading(false);
      }
    },
    [activeDatabase, sparaBildMutation, gravId]
  );

  return { sparaBild, loading, error };
};
